export const uppercaseOnlyFirstLetter = (name: string = '') =>
  name
    .split('_')
    .map((segment) => {
      if (segment === 'ID') return segment;

      return segment[0] + (segment.length > 1 ? segment.substring(1).toLowerCase() : '');
    })
    .join(' ');

export function generateTypeName<S extends string = ''>(type: S | null | undefined): string {
  return type ? uppercaseOnlyFirstLetter(type) : '';
}
